import React from "react";

import { Button } from "ii-ui-kit";

import keyImg from "images/key.png";
import "./incorrect-password-error.scss";

/** Ошибка: "Неверный пароль "*/
export const IncorrectPasswordError = () => {
  const goToMain = () => {
    if (window.loginRestartFlowUrl) {
      window.location.replace(window.loginRestartFlowUrl);
    }
  };

  return (
    <div className="incorrect-password-error">
      <img className="incorrect-password-error__img" src={keyImg} />
      <div className="incorrect-password-error__title">
        Неверное имя пользователя или пароль
      </div>
      <Button
        className="incorrect-password-error__button"
        title={"Вернуться на главную"}
        size={"l"}
        onClick={goToMain}
      />
    </div>
  );
};
